import { useCallback } from 'react';
import { useStoreValue } from 'store';

export const useEnv = () => {
  const [storeValue = {}] = useStoreValue() || [];

  const getEnv = useCallback(
    envName => {
      if (!envName) {
        if (import.meta.env.VITE_ENV === 'prod') {
          return import.meta.env;
        }
        return { ...import.meta.env, ...storeValue.overriddenEnv };
      }

      if (import.meta.env.VITE_ENV === 'prod') {
        return import.meta.env[envName];
      }

      return storeValue.overriddenEnv?.[envName] || import.meta.env[envName];
    },
    [storeValue.overriddenEnv],
  );

  return getEnv;
};

export const useOverrideDevEnv = () => {
  const [storeValue = {}, updateStore] = useStoreValue() || [];

  const overrideEnv = useCallback(
    (envName, envValue) => {
      updateStore({
        overriddenEnv: {
          ...storeValue.overriddenEnv,
          [envName]: envValue,
        },
      });
    },
    [storeValue.overriddenEnv, updateStore],
  );

  return overrideEnv;
};
